import { schema } from "normalizr";

export const artistPreviewSchema = new schema.Entity("artistPreviews");
export const artistSchema = new schema.Entity("artists");

export const artistOptionsSchema = new schema.Entity("artistOptions");
